import { render } from "./App.vue?vue&type=template&id=768bfdac"
const script = {}

import "./App.vue?vue&type=style&index=0&id=768bfdac&lang=scss"
script.render = render

export default script